import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wex25zkj7: FaireProductEntity = {
  token: "p_5wex25zkj7",
  type: "product",
  name: "Deep Conditioner",
  brandToken: "b_aozh3p8j9i",
  brandName: "Original Sprout",
  imageUrl:
    "https://cdn.faire.com/fastly/5bb439844309b63886182cf5287dc767717253ca2bc60fdb3387bfc46620c394.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c2a06078b30a3866415d35828ebc27b79e3e926d79e9a710eaf6638c8a34fc2.png",
    "https://cdn.faire.com/fastly/76135dfb249266bc5437ec77dad4ca285330a9588482c489c858ebd3c4b9f335.png",
    "https://cdn.faire.com/fastly/12f8265dafd502abc4b9521f211fb6e0102585391d2e4e705ca1008aba7c73b6.png",
    "https://cdn.faire.com/fastly/107e9b975be02b282dafefeb00806ff8457547f589290467e71a70f825ff5c7e.png",
    "https://cdn.faire.com/fastly/619e979dcdf494ebd6ee233384858923e7dace6d971cc9fd246b5f1c2292ab9a.png",
    "https://cdn.faire.com/fastly/7777e3019d5ceeb704cbd5cd6e25fa80a519fea940100d90475bb43698a5a37b.jpeg",
  ],
  priceDollars: 23,
  description:
    "Original sprout deep conditioner is infused with hawaiian kukui seed oil to help repair hair, leaving it silky and smooth. Apply onto ends for optimal moisture and movement, leave on hair for at least five minutes. For a deeper treatment, try wrapping hair in a warm towel or shower cap for 15 minutes to help the ingredients penetrate deeper before rinsing. \n \n*Tree nuts used in the following products include: Kukui nuts.\n Features\n\nGentle pH of 4.5 – 5.5.\nFor children and adults.\nKey ingredients: rosemary and calendula.\nFor all hair types and textures.\nRich in moisture and protein.\nOrganic extracts leave hair soft, smooth and silky without weighing it down.\nNo soy, gluten, honey, peanut or dairy.\nVegan.",
  tags: [],
  msrpDollars: 45.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:22.378Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
